import React from "react"
import { Outlet, useLocation } from "react-router-dom"

import { Box, Tabs, TabList, Tab, TabPanel, TabPanels } from "@chakra-ui/react"
import Link from "./Link"

export default function AccountTabs() {
  const location = useLocation()

  const getTabIndex = React.useCallback(() => {
    if (location.pathname.includes("/account")) {
      return 0
    } else if (location.pathname.includes("/users")) {
      return 1
    } else if (location.pathname.includes("/profile")) {
      return 2
    } else if (location.pathname.includes("/identities")) {
      return 3
    } else if (location.pathname.includes("/requests")) {
      return 4
    } else if (location.pathname.includes("/materials")) {
      return 5
    } else {
      return 6
    }
  }, [location.pathname])

  return (
    <Box>
      <Tabs variant="base" index={getTabIndex()}>
        <TabList>
          <Tab>
            <Link to="/account" style={{ textDecoration: "none" }}>
              Account
            </Link>
          </Tab>
          <Tab>
            <Link to="/users" style={{ textDecoration: "none" }}>
              Users
            </Link>
          </Tab>
          <Tab>
            <Link to="/profile" style={{ textDecoration: "none" }}>
              Profile
            </Link>
          </Tab>
          <Tab>
            <Link to="/identities" style={{ textDecoration: "none" }}>
              Identities
            </Link>
          </Tab>
          <Tab>
            <Link to="/requests" style={{ textDecoration: "none" }}>
              Requests
            </Link>
          </Tab>
          <Tab>
            <Link to="/materials" style={{ textDecoration: "none" }}>
              Materials
            </Link>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Outlet />
          </TabPanel>
          <TabPanel>
            <Outlet />
          </TabPanel>
          <TabPanel>
            <Outlet />
          </TabPanel>
          <TabPanel>
            <Outlet />
          </TabPanel>
          <TabPanel>
            <Outlet />
          </TabPanel>
          <TabPanel>
            <Outlet />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
